/** メールアドレスの形式エラーメッセージ */
export const EMAIL_FORMAT_MESSAGE = 'メールアドレスの形式が正しくありません。';

const EMAIL_RE = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/**
 * @param {string} value
 * @returns {boolean}
 */
export function isValidEmail(value) {
	if (typeof value !== 'string') return false;
	return EMAIL_RE.test(value.trim());
}
